// extracted by mini-css-extract-plugin
export var table = "_yx-0";